module.exports = __webpack_public_path__ + "media/customizations/teravalis/back-37e73c6689f01e7070f05930d6b31e22.jpg";